import MonthlyCalendarController from 'uplisting-frontend/pods/monthly/controller';
import type MonthlyCalendarRatesRoute from 'uplisting-frontend/pods/monthly/rates/route';
import type MonthlyCalendarMlosRoute from 'uplisting-frontend/pods/monthly/mlos/route';
import type MonthlyCalendarBulkArrivalRoute from 'uplisting-frontend/pods/monthly/bulk-arrival/route';
import type MonthlyCalendarBulkDepartureRoute from 'uplisting-frontend/pods/monthly/bulk-departure/route';
import { type BulkStayStrategyChangeset } from 'uplisting-frontend/components/ui/stay-strategy/v1';

type RouteContext =
  | MonthlyCalendarRatesRoute
  | MonthlyCalendarMlosRoute
  | MonthlyCalendarBulkArrivalRoute
  | MonthlyCalendarBulkDepartureRoute;

export function assignPropertyToChangeset(
  context: RouteContext,
  changeset: BulkStayStrategyChangeset,
): void {
  const controller = context.controllerFor(
    'monthly',
  ) as MonthlyCalendarController;
  changeset.properties = [controller.property];
}
